
import { useState } from 'react';

const FloatingButtons = () => {
  const [hovered, setHovered] = useState<string | null>(null);

  const buttons = [
    {
      id: 'facebook',
      icon: 'ri-facebook-fill',
      label: '粉絲專頁',
      href: 'https://www.facebook.com/p/前金社區日間照顧機構-100063908289224/',
      bgColor: 'bg-[#A8D5E2]',
      hoverBg: 'hover:bg-[#7EC8D8]',
      textColor: 'text-white',
    },
    {
      id: 'phone',
      icon: 'ri-phone-fill',
      label: '07-2416568',
      href: 'tel:0724165680',
      bgColor: 'bg-[#F9E4A0]',
      hoverBg: 'hover:bg-[#F5D76E]',
      textColor: 'text-[#7a6a2a]',
    },
  ];

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-3 pr-0">
      {buttons.map((btn) => (
        <a
          key={btn.id}
          href={btn.href}
          target={btn.id === 'facebook' ? '_blank' : undefined}
          rel={btn.id === 'facebook' ? 'noopener noreferrer' : undefined}
          onMouseEnter={() => setHovered(btn.id)}
          onMouseLeave={() => setHovered(null)}
          className={`
            flex items-center gap-2 cursor-pointer whitespace-nowrap
            ${btn.bgColor} ${btn.hoverBg} ${btn.textColor}
            rounded-l-2xl shadow-lg
            transition-all duration-300 ease-in-out
            overflow-hidden
            ${hovered === btn.id ? 'pr-4 pl-3 py-3' : 'px-3 py-3'}
          `}
          style={{
            maxWidth: hovered === btn.id ? '180px' : '52px',
            transition: 'max-width 0.35s cubic-bezier(0.4,0,0.2,1), padding 0.3s',
          }}
        >
          <span className="w-7 h-7 flex items-center justify-center flex-shrink-0">
            <i className={`${btn.icon} text-xl`}></i>
          </span>
          <span
            className={`text-sm font-semibold overflow-hidden whitespace-nowrap transition-all duration-300 ${
              hovered === btn.id ? 'opacity-100 w-auto' : 'opacity-0 w-0'
            }`}
          >
            {btn.label}
          </span>
        </a>
      ))}
    </div>
  );
};

export default FloatingButtons;
